export default "__VITE_ASSET__B3dSN7GU__"